import { Link } from 'react-router-dom';
import founder from '@/assets/home-v2/rafael-natural.webp.asset.json';
import { Reveal, Eyebrow, H2 } from './shared';

export const FounderV2 = () => (
  <Reveal as="section" className="bg-v2-bg py-16 text-v2-ink md:py-24">
    <div className="container mx-auto grid max-w-6xl items-center gap-8 px-5 md:grid-cols-[minmax(260px,0.8fr)_1.2fr] md:gap-14">
      <div className="mx-auto aspect-[4/5] w-full max-w-sm overflow-hidden rounded-2xl bg-v2-blue/10">
        <img
          src={founder.url}
          alt="Rafael Di Falco Cossiello, fundador da NAT HOF"
          width={746}
          height={900}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div>
        <Eyebrow>Quem está por trás</Eyebrow>
        <H2>Uma marca criada por quem viu de perto a pele de quem ama sofrer.</H2>
        <p className="mt-5 leading-relaxed text-v2-muted">
          Sou Rafael Cossiello, químico, mestre e doutor pela Unicamp, com anos de pesquisa em emulsões na indústria. Em 2005, eu levava meus avós às sessões de quimioterapia e vi o quanto a pele sofre — e o quanto um produto errado incomoda. A NAT HOF nasceu daí: fórmulas sem perfume, testadas em laboratório independente, para quem não pode errar com a própria pele. O nome vem da minha esposa, Natália Hoffmann.
        </p>
        <p className="mt-5 font-semibold text-v2-ink">Rafael Di Falco Cossiello · Fundador</p>
        <Link to="/sobre" className="mt-5 inline-flex min-h-12 items-center font-semibold text-v2-ink underline underline-offset-4">
          Conheça nossa história
        </Link>
      </div>
    </div>
  </Reveal>
);